// popin-react/src/components/creator-report/MultipleRatingReportSummary.jsx

import React from 'react';

import RatingDistribution from '../../components/shared/RatingDistribution';
import  CommentsSummary  from './CommentsSummary';
import  MultiRatingHeader  from './MultiRatingHeader';
import Ideas from '../../models/Ideas';

import './AverageBreakdown.css';

const MultipleRatingReportSummary = ({ event, ideas, ratingDistributionByIdeaId = {}, commentsByIdeaId = {} }) => {
  return (
    <div className="multi-rating print">
      {
        ideas.map((idea, index) => (
          <div key={Ideas.getId(idea) || index}>
            <MultiRatingHeader
              index={index}
              idea={idea} />
            <RatingDistribution 
              event={event}
              idea={idea}
              initialDistribution={ ratingDistributionByIdeaId[Ideas.getId(idea)] } />
            <CommentsSummary
              event={event}
              idea={idea}
              initialComments={ commentsByIdeaId[Ideas.getId(idea)] } />
          </div>
        ))
      }
    </div>
  );
};

export default MultipleRatingReportSummary;
